module.exports = __webpack_public_path__ + "img/boxy_background_3.f437cabc.jpg";